import type { BoxProps } from '@chakra-ui/react';
import { Box } from '@chakra-ui/react';
import React from 'react';

export type SurfaceCardProps = React.PropsWithChildren<BoxProps & {

  /**
   * 是否在移动端（base）禁用卡片视觉（背景/边框/阴影）。
   *
   * - `true`：移动端变为“无卡片外框”，仅保留布局属性；PC(lg+) 保持卡片样式
   * - `false`：全断点保持卡片样式（默认）
   *
   * 典型场景：列表页/表格页的最外层容器在移动端不需要额外卡片外框。
   */
  disableMobileCardStyle?: boolean;
}>;

/**
 * 通用卡片容器（全局复用）。
 *
 * 默认样式：
 * - Background: `bg.primary`
 * - Border: `border.default`
 * - Shadow: `shadows.card`
 *
 * 说明：
 * - 你可以通过 props 覆盖任何样式（例如 `bgColor`）。
 * - 对于“页面最外层容器”这类场景，可使用 `disableMobileCardStyle` 在移动端关闭外框。
 */
const SurfaceCard = ({ children, disableMobileCardStyle = false, ...props }: SurfaceCardProps) => {
  return (
    <Box
      bgColor={ disableMobileCardStyle ? { base: 'transparent', lg: 'bg.primary' } : 'bg.primary' }
      borderWidth={ disableMobileCardStyle ? { base: 0, lg: '1px' } : '1px' }
      borderColor={ disableMobileCardStyle ? { base: 'transparent', lg: 'border.default' } : 'border.default' }
      borderRadius={ disableMobileCardStyle ? { base: 0, lg: 'base' } : 'base' }
      boxShadow={ disableMobileCardStyle ? { base: 'none', lg: 'card' } : 'card' }
      { ...props }
    >
      { children }
    </Box>
  );
};

export default React.memo(SurfaceCard);
